import React, { useState, useEffect } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { HHIEButton } from './HHIEButton';

export function HelpAlert({ user, account }) {
    const [showAlert, setShowAlert] = useState(true)
    const [previousRequest, setPreviousRequest] = useState(false)

    useEffect(() => {
        CheckAssistanceRequested();
    }, [user])

    const CheckAssistanceRequested = () => {
        if (user.isPOCUser) {
            fetch('/api/Registration/previous-assistance-requested/' + user.sfid + '/' + account.id)
                .then((response) => {
                    response.json()
                        .then((serviceDiscussionRequested) => {
                            if (serviceDiscussionRequested.errors !== null && serviceDiscussionRequested.errors !== "") alert(serviceDiscussionRequested.errors)
                            setPreviousRequest(serviceDiscussionRequested.message)
                        })
                        .catch((discussionError) => {
                            console.log("service Discussion json error: " + discussionError)
                        })
                })
                .catch((discussionResponseError) => {
                    console.log("serviceDiscussionResponse Error: " + discussionResponseError)
                })
        }
    }



    const RequestAssistance = () => {
        const formData = new FormData();
        formData.append("userId", user.sfid)
        formData.append("account", account.id)

        const requestOptions = {
            method: "POST",
            body: formData
        }
        fetch('/api/Registration/RequestAssistance', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        if (text.message.includes("Success")) {
                            CheckAssistanceRequested()
                        }
                        alert(text.message);
                    })
                    .catch((error) => {
                        console.log("requestDiscussion Text Error: " + error);
                    })
            })
            .catch((error) => {
                console.log("requestDiscussion Response Error: " + error);
            });
    }

    return (
        <Row>
            <Col className="d-flex justify-content-center">
                <Alert
                    variant="success"
                    style={{ borderRadius: '10px' }}
                    className="justify-content-center"
                    onClose={() => { setShowAlert(false) }}
                    dismissible
                    show={user.isPOCUser
                        && showAlert
                    }
                >
                    {!previousRequest ?
                        <Row>
                            <Col className="d-flex justify-content-center">
                                Need help? Contact the HHIE
                            </Col>
                            <Col className="d-flex justify-content-right" sm={6}>
                                <HHIEButton
                                    variant="primary"
                                    className="justify-content-right"
                                    size="sm"
                                    onClick={() => {
                                        RequestAssistance();
                                    }}
                                    title="Request assistance"
                                    visible={!user.isPOCUser?"true":"false"}
                                />
                            </Col>
                        </Row>
                        :
                        <>Someone from the HHIE will reach out soon regarding your request for assistance</>
                    }
                </Alert>
            </Col>
        </Row>
    )
}
